import React, { Component } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import CookieConsentComponent from '../../Components/CookieConsent'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { connect } from 'react-redux'
// import heroWallet from '../../images/hero-wallet.png'
import background from '../../images/circleBackground.svg'
import background2 from '../../images/background2.svg'
import background3 from '../../images/background3.svg'
import coin from '../../images/coin.svg'
import key from '../../images/key.svg'
import moneys from '../../images/moneys.svg'
import receipt from '../../images/receipt-disscount.svg'
import receiptSearch from '../../images/receipt-search.svg'
import walletCheck from '../../images/wallet-check.svg'
import more from '../../images/more-2.svg'
import arrow from '../../images/programming-arrow.svg'
// import walletReceber from '../../images/wallet_btc-receber.png'
// import walletConversao from '../../images/wallet_conversao.png'
import shop from '../../images/shop.svg'
import { Link } from 'react-router-dom'
import './produtosWallet.css'

const items1 = [
    {
        icon: coin,
        text: "Milhares de estabelecimentos aceitam bitcoin como pagamento e você pode utilizar sua carteira para pagar diretamente em crypto, sem intermediários."
    },
    {
        icon: walletCheck,
        text: "Nossa carteira tem todas as funcionalidades de um banco digital, você pode pagar o que quiser ou transferir diretamente R$ através de Pix, TED ou Boleto."
    },
    {
        icon: shop,
        text: "Caso você seja um prestador de serviços ou comerciante, ofereça para seus clientes a forma de pagamento mais inovadora do mundo, fuja das taxas abusivas das maquininhas e ainda ganhe cashback."
    },
]

const items2 = [
    {
        icon: more,
        text: "Nossa carteira utiliza a tecnologia mais segura e avançada para a custódia dos ativos. Multi-Party Computation (MPC) é referência mundial para instituições e negócios no setor de Blockchain & Crypto."
    },
    {
        icon: key,
        text: "A chave privada de uma carteira que utiliza a tecnologia MPC é constituída por ‘key shares’ que nunca entram em contato entre si, até mesmo durante sua criação. Por isso, a chave permanece sempre segura."
    },
    {
        icon: receipt,
        text: "Sem taxas abusivas: Utilizando nossa carteira, você paga somente a taxa de rede ao enviar crypto para outros endereços. Além disso, por conta de nossa tecnologia seus custos de saque são reduzidos em até 90%."
    },
]

const items3 = [
    {
        icon: arrow,
        text: "Você não enfrenta livros de ofertas como nas corretoras e por isso não fica suscetível a manipulação de grandes market makers."
    },
    {
        icon: receiptSearch,
        text: "Sem taxas escondidas:\nVocê sabe exatamente quanto vai pagar antes de utilizar qualquer serviço."
    },
    {
        icon: moneys,
        text: "Utilizamos liquidez própria nas conversões. Parte dela é composta pelos fundos provenientes da venda de nosso token FLWT. Você pode contribuir e ser recompensado por isso."
    },
]

class ProdutosWallet extends Component {
    constructor() {
        super();
          this.state = {
          fillBackground: false,
        };
      }

    componentDidMount = async () => {
        const { onLoad, userid, logged } = this.props
        if(logged && onLoad && userid) {
            onLoad(userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    render() {
        return (
            <div id="sobreSection">
                <Navbar fillBackground={this.state.fillBackground} />
                <div className="section sobreWrapper headerWrapper">
                    <Container >
                        <Row>
                            <Col md={12} className="p-0 d-flex flex-column align-items-center">
                                <h2 className="pageCall">Descubra um <br/><span class="tx-pink">novo jeito</span> de se <br/>relacionar com <br/>crypto</h2>
                                <p className="headerDescProducts">Nossa carteira te dá <span class="tx-pink">segurança, liberdade e controle</span> sobre o seu dinheiro</p>
                                <Link to="/cadastro" className='anchorBtn m-0'>Inicie sua jornada</Link>
                            </Col>
                        </Row>
                    </Container>
                        <div className="backgroundWrapper">
                                <img src={background} className="back-product"/>
                                {/* <img src={heroWallet} className="img-product"/> */}
                        </div>
                    <Container>
                        <Row>
                            <Col md={12} className="d-flex justify-content-center mt-5">
                                <h2 className="text-white subtitlePages">Pague o que quiser, onde quiser, utilizando R$ ou Crypto</h2>
                            </Col>
                            {items1.map(item => (
                                <Col md={4} className="d-flex justify-content-center mt-5 mb-0">
                                    <div className="wrapperItemWallet">
                                        <img src={item.icon} />
                                        <p>{item.text}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>

                    <div className="backgroundWrapper2">
                        <img src={background2} className="back-product"/>
                        {/* <img src={walletReceber} className="img-product2"/> */}
                    </div>

                    <Container>
                        <Row>
                            <Col md={12} className="d-flex justify-content-center">
                                <h2 className="text-white subtitlePages">Armazene suas criptomoedas com a tecnologia mais segura no mercado</h2>
                            </Col>
                            {items2.map(item => (
                                <Col md={4} className="d-flex justify-content-center mt-5 mb-0">
                                    <div className="wrapperItemWallet">
                                        <img src={item.icon} />
                                        <p>{item.text}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>

                    <div className="backgroundWrapper2">
                        <img src={background3} className="back-product"/>
                        {/* <img src={walletConversao} className="img-product2"/> */}
                    </div>
                    
                    <Container>
                        <Row>
                            <Col md={12} className="d-flex justify-content-center">
                                <h2 className="text-white subtitlePages">Compre e venda Bitcoin de forma instantânea com as menores taxas</h2>
                            </Col>
                            {items3.map(item => (
                                <Col md={4} className="d-flex justify-content-center mt-5 mb-0">
                                    <div className="wrapperItemWallet">
                                        <img src={item.icon} />
                                        <p>{item.text}</p>
                                    </div>
                                </Col>
                            ))}
                            <Col md={12} className="mt-5 mb-5 d-flex justify-content-center">
                                <Link to="/cadastro" className='anchorBtn'>Abra a sua conta</Link>
                            </Col>
                        </Row>
                    </Container>
                </div>
            
                <CookieConsentComponent />
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ProdutosWallet)